import { useState } from "react"
import { MdClose } from "react-icons/md"
import { useGetAllAppointments } from "../functions/queue"

const width = window.innerWidth

const styles = {
    navWrapper: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        margin: "0 20px",
        margin: "10px 0",
        borderWidth: 2,
        borderColor: "red",
        borderRadius: 50,
        overflow: "hidden"
    },
    optionsPicker: {
        padding: "10px 0",
        // paddingHorizontal: 15,
        width: (width - 40) / 3
    },
    optionLabel: {
        textAlign: "center"
    },
    appointment: {
        display: "flex",
        flexDirection: "row",
        margin: "10px",
        paddingBottom: 15,
        borderBottomWidth: 1,
        borderBottomColor: "rgb(240,240,240)",
        alignItems: "center"
    },
    iconWrapper: {
        width: 45,
        height: 45,
        backgroundColor: "red",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 50,
        margin: "0 20px 0 10px",
    }
}

export default function Appointment({ navigation: {goBack}}) {

    const [group, setGroup] = useState(null)

    const { onQueue, missed, completed } = useGetAllAppointments()

    const data = !group ? onQueue : group === "missed" ? missed : completed

    return (
        <>
            <div style={{ width: "100vw", height: "100vh", backgroundColor: "#141414" }}>
                <div style={{ display: "flex", "flexDirection": "row", alignItems: "center", padding: "10px 0" }}>
                    <div onClick={goBack} style={{ padding: 15 }}>
                        <MdClose size={25} color="#FFF" />
                    </div>
                    <p style={{ fontSize: 25, fontWeight: 'bold', margin: 15, color: "#FFF"}}>Appointments</p>
                </div>
                <div style={styles.navWrapper}>
                    <div onClick={() => setGroup(null)} style={{ ...styles.optionsPicker, background: !group ? "red" : "white" }}>
                        <p style={{ ...styles.optionLabel, color: !group ? "white" : "red" }}>
                            On Queue
                        </p>
                    </div>
                    <div onClick={() => setGroup("complete")} style={{ ...styles.optionsPicker, background: group === "complete" ? "red" : "white" }}>
                        <p style={{ ...styles.optionLabel, color: group === "complete" ? "white" : "red" }}>
                            Completed
                        </p>
                    </div>
                    <div onClick={() => setGroup("missed")} style={{ ...styles.optionsPicker, background: group === "missed" ? "red" : "white" }}>
                        <p style={{ ...styles.optionLabel, color: group === "missed" ? "white" : "red" }}>
                            Missed
                        </p>
                    </div>
                </div>
                <div>
                    {data.map(item => (
                        <div style={styles.appointment} key={item._id}>
                            <div style={styles.iconWrapper}>
                                <p style={{ color: "white", fontSize: 20, fontWeight: "bold"}}>{item.queuedAt}</p>
                            </div>
                            <div>
                                <p style={{ fontSize: 16, textTransform: "capitalize", color: "white" }}>{item.otherUser?.names || item.user.fullnames}</p>
                                {item.info.symptoms.map((symptom, index) => (
                                    <div key={symptom}>
                                        <p style={{ color: "white" }}>({index + 1}) {symptom}</p>
                                    </div>
                                ))}
                                <p style={{ marginTop: 10, color: "#FFF" }}>{item.DOA}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}